function PasswordUtils() {
	this.getStrength = function(scope, score) {
		if (score === 0) return 0;
		var username;
		var firstName;
		var lastName;
		var user;
		if (globalConfig && (user = globalConfig.user)) {
			username = user.userName;
			firstName = user.firstName;
			lastName = user.lastName;
		}
		scope.usernameLoaded = !!username; // If username is not loaded the form will error on submission
		var emailUsernameEndIndex = username ? username.indexOf('@') : -1;
		var emailUsername = emailUsernameEndIndex > 0 
			? username.slice(0, emailUsernameEndIndex)
			: '';
		// remove empty strings and undefined or null values
		function removeFalsyValues (arr) {
			return arr.filter(function(item) {
				return item;
			});
		};
		var bannedWords = removeFalsyValues([emailUsername, username, 'leandna']);
		var cautionWords = removeFalsyValues([firstName, lastName]);
		var strength = score;
		var password = scope.newPassword;
		// Passwords that contain variations of leandna (e.g. l3@NdNa) or variations of a username are weak
		if (leandnaStore.passwordUtils.doesPasswordContainWords(bannedWords, password)) {
			return 1;
		}
		// Check if the password contains four or more consecutive characters (or similar varitaions) from a username
		// Or if the password contains any variant of the user's first or last name
		// If so, the password is considered to be one category weaker than it would otherwise be
		if (
			!username
			|| leandnaStore.passwordUtils.doesPasswordContainWordParts(username, password)
			|| leandnaStore.passwordUtils.doesPasswordContainWords(cautionWords, password)
		) {
			return strength - 1;
		}
		return strength;
	};

	this.checkStrength = function(scope, sce) {
		scope.passwordTooShort = true;
		scope.passwordNeedsUppercaseLetter = true;
		scope.passwordNeedsLowercaseLetter = true;
		scope.passwordNeedsSymbol = true;
		if (scope.newPassword !== undefined) {
			scope.passwordTooShort = scope.newPassword.length < 12;
			scope.passwordNeedsUppercaseLetter = !(/[A-Z]/.test(scope.newPassword));
			scope.passwordNeedsLowercaseLetter = !(/[a-z]/.test(scope.newPassword));
			scope.passwordNeedsSymbol = !(/[^a-zA-Z0-9]+/.test(scope.newPassword));
			// zxcvbn.js
			var analysis = zxcvbn(scope.newPassword);
			scope.strength = this.getStrength(scope, analysis.score);
			scope.strengthDescription = ({
				0: 'very weak',
				1: 'weak',
				2: 'moderate',
				3: 'good',
				4: 'excellent'
			})[scope.strength];
			scope.strengthPercentage = ({
				0: '10%',
				1: '25%',
				2: '50%',
				3: '75%',
				4: '100%'
			})[scope.strength];
			this.updateTooltipContent(analysis, scope, sce);
		}
		this.checkRequirements(scope);
	};

	this.updateTooltipContent = function(analysis, scope, sce) {
		var htmlContent = '';
		var orig = 'Add another word or two. Uncommon words are better.',
			repl = 'Try mixing letters, numbers and symbols, or adding a word or two. Uncommon words are better.';
		var suggestions = analysis.feedback.suggestions.map(function(s) {
			return s === orig ? repl : s;
		});
		if (analysis.feedback.warning !== '' ||
				suggestions.length > 0) {
			htmlContent = '<div class="tooltipBody">';
			if (analysis.feedback.warning !== '') {
				htmlContent += '<div translate>' + analysis.feedback.warning + '</div>';
			}
			if (suggestions.length === 1) {
				htmlContent += '<div translate>' + suggestions[0] + '</div>';
			} else if (suggestions.length > 1) {
				htmlContent += '<div>';
				htmlContent += '<span translate>Consider</span>:';
				htmlContent += '<ul>';
				for (i = 0; i < suggestions.length; i++) {
					htmlContent += '<li translate>' + suggestions[i] + '</li>';
				}
				htmlContent += '</ul></div>';
			}
			htmlContent += '</div>';
		}
		scope.strengthTooltip = sce.trustAsHtml(htmlContent);
	};

	this.checkRequirements = function(scope) {
		scope.newPasswordError = 
			scope.newPassword ? (
				scope.passwordTooShort ? 'New Password is too short' :
					scope.strength <= 2 ? 'Password is too weak' :
						undefined
			)
				: undefined;

		scope.confirmPasswordError =
			scope.newPassword !== scope.confirmNewPassword ? 'New Password and Confirm New Password must match' : undefined;

		scope.passwordProblemType = (
			scope.newPassword === '' ? 'New Password must not be blank' :
				(scope.newPasswordError || scope.confirmPasswordError));
	};
}
